import { atom } from 'jotai';
import { Message } from '../typings/message-types';
import { FrequencyCappingState } from '../../../../shared/typings/frequency-capping';

interface BroadcastMessageInfo {
  messageId: string;
  chatId: string;
  pageDetail: string;
  buttonText: string;
  chatTypeId: string;
  linkId: string;
  cardIndex?: number;
  nextScheduledAt?: string;
  retryFailedMessages?: boolean;
  showRetrySettings?: boolean;
  frequencyCappingState?: FrequencyCappingState;
  showTemplateInfo?: boolean;
}

type MessageInfo = {
  message: Message;
  customerId: string;
  chatId: string;
};

interface BroadcastMembersInfo {
  channelId: string;
}
interface BroadcastMsgDetailsType {
  messageId: string;
  chatId: string;
  channelId: string;
}

export enum DetailsPanelState {
  NONE = 'none',
  CUSTOMER_DETAILS = 'customer-details',
  BROADCAST_MESSAGE = 'broadcast-message',
  MESSAGE_INFO = 'message-info',
  BROADCAST_MEMBERS = 'broadcast-members',
  AI_CHAT_SUMMARY = 'ai-chat-summary',
}

type DetailsPanelAtom =
  | {
      open: false;
    }
  | (
      | {
          open: boolean;
          type: DetailsPanelState.CUSTOMER_DETAILS;
        }
      | { open: boolean; type: DetailsPanelState.MESSAGE_INFO; data: MessageInfo }
      | {
          open: boolean;
          type: DetailsPanelState.BROADCAST_MESSAGE;
          data: BroadcastMessageInfo;
        }
      | {
          open: boolean;
          type: DetailsPanelState.BROADCAST_MEMBERS;
          data: BroadcastMembersInfo;
        }
      | {
          open: boolean;
          type: DetailsPanelState.AI_CHAT_SUMMARY;
          // data: BroadcastMembersInfo;
        }
    );

export const detailsPanelAtom = atom<DetailsPanelAtom>({
  open: false,
});
